import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

@Component({
	selector: 'app-user-ans',
	templateUrl: './user-ans.component.html',
	styleUrl: './user-ans.component.scss'
})
export class UserAnsComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		}
	];
	refNo: any = null;
	idList: any[] = [];
	pagetitle = "User Answers";
	showLoader: boolean = false;
	pageLoading1: boolean = false;
	pageLoading2: boolean = false;
	pageLoading3: boolean = false;
	details: any = null;
	apptList: any[] = [];
	apptListFiltered: any[] = [];
	customError: any = {};
	hideP = true;
	formSubmitted = false;
	trainerList: any[] = [];
	filters: any = {
		trainer: null
	};
	/* displayFlag = "show"; */

	constructor(private toastr: ToastrService, private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			const urlParam = routeParams["Id"];
			const idList = urlParam.split("__");
			this.refNo = idList[0];
			for (let i = 1; i < idList.length; i++) {
				this.idList.push(parseInt(idList[i]));
			}
			this.breadcrumbList.push({ path: "/app/userans/" + urlParam, name: this.pagetitle });
			this.getDetails();
			this.getTrainers();
		});
	}

	getTrainers() {
		this.apiService.listTrainers().subscribe({
			next: (data: any) => {
				this.trainerList = data.map((t: any) => {
					t.full_name = `${t.first_name} ${t.last_name}`;
					return t;
				});
			}, error: (error) => {
				this.trainerList = [];
				if (error.status == 401) { return }
			}
		});
	}

	/* trainerChanged() {
		if (!this.filters.trainer) {
			this.apptListFiltered.map((a) => {
				a[this.displayFlag] = true;
			})
		} else {
			this.apptListFiltered.map((a) => {
				if (a.trainers_id == this.filters.trainer) {
					a[this.displayFlag] = true;
				} else {
					a[this.displayFlag] = false;
				}
			})
		}
	} */

	/* getDisplayApptCount() {
		return this.apptListFiltered.filter((a) => a[this.displayFlag]).length;
	} */

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getApptDetails(this.refNo).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				if (data.length) {
					this.details = data[0];
					this.apptListFiltered = data.filter((a) => this.idList.indexOf(a.id) >= 0);/* .map((a) => {
						a[this.displayFlag] = true;
						return a;
					}); */
					this.getQuestions();
					this.getNotes();
				} else {
					this.toastr.error("Unable to fetch details.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getQuestions() {
		if (this.details && this.details.profile) {
			this.pageLoading2 = true;
			this.apiService.getQuestionsFromProfileAndAnswers(this.details.profile, this.apptListFiltered.map((a) => a.encrypt_id)).subscribe({
				next: (response: any) => {
					let data1 = response[response.length - 1];
					this.apptListFiltered.map((appt, i) => {
						let answers = response[i];
						let categoryWiseQues = JSON.parse(JSON.stringify(data1));
						categoryWiseQues.map((cat) => {
							cat.isExpanded = false;
							cat.que_list.map((que) => {
								try {
									/* Select "Default" answer by default */
									que.ans = que.Value.filter(v => v.ans == "default")[0].value;
								} catch (error) { }
								try {
									/* Select saved answer */
									let savedAns = answers.find((answer) => answer.que_ids === que.question_id);
									if (savedAns) {
										que.ans = savedAns?.ans
									}
								} catch (error) { }
								return que;
							});
							return cat;
						});
						appt["categoryWiseQues"] = categoryWiseQues;
						return appt;
					});
					this.pageLoading2 = false;
				}, error: (error) => {
					this.pageLoading2 = false;
					if (error.status == 401) { return }
					this.toastr.error("Unable to fetch details.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		}
	}

	getNotes() {
		this.pageLoading3 = true;
		this.apiService.getNotes(this.apptListFiltered.map((a) => a.encrypt_id)).subscribe({
			next: (response: any) => {
				this.apptListFiltered.map((appt, i) => {
					appt["notes"] = response[i];
					return appt;
				});
				this.pageLoading3 = false;
			}, error: (error) => {
				this.pageLoading3 = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveNotesLoader: any = null;
	saveSingleNotes(appt: any) {
		const data = {
			id: appt.encrypt_id,
			flag: "save",
			notes: appt.notes
		}
		this.saveNotesLoader = appt.id;
		this.apiService.get_save_SingleNotes(data).subscribe({
			next: (res: any) => {
				const data = {
					id: appt.encrypt_id,
					flag: "get",
					notes: appt.notes
				}
				this.apiService.get_save_SingleNotes(data).subscribe({
					next: (data: any) => {
						appt.notes = data;
						this.saveNotesLoader = null;
						this.toastr.success("Saved successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}, error: (error) => {
						this.saveNotesLoader = null;
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}, error: (error) => {
				this.saveNotesLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveSingle(appt_id: any, que_id: any, ans: any) {
		if (ans === undefined || ans === null || ans === "") { } else {
			const payload = {
				"user_id": appt_id,
				"que_ids": que_id,
				"ans": ans
			}
			this.apiService.saveSingleAns(payload).subscribe({
				next: (data: any) => { }, error: (error) => { }
			});
		}
	}

	saveAllAnswers() {
		this.showLoader = true;
		let ans_list: any[] = [];
		let id_list: any[] = [];
		let len1 = this.apptListFiltered.length;
		for (let i = 0; i < len1; i++) {
			id_list.push(this.apptListFiltered[i].encrypt_id);
			let len2 = this.apptListFiltered[i].categoryWiseQues.length;
			for (let j = 0; j < len2; j++) {
				let len3 = this.apptListFiltered[i].categoryWiseQues[j].que_list.length;
				for (let k = 0; k < len3; k++) {
					const ans = this.apptListFiltered[i].categoryWiseQues[j].que_list[k].ans;
					if (ans === undefined || ans === null || ans === "") {
						this.toastr.error("Please answer all questions.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						return;
					} else {
						ans_list.push({
							"user_id": this.apptListFiltered[i].encrypt_id,
							"que_ids": this.apptListFiltered[i].categoryWiseQues[j].que_list[k].question_id,
							"ans": ans
						});
					}
				}
			}
		}
		this.apiService.saveAllAns({ ans_list: ans_list }).subscribe({
			next: (data: any) => {
				this.apiService.saveScore(id_list).subscribe({
					next: (res) => {
						this.showLoader = false;
						this.toastr.success("Saved successfully.", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.router.navigate(['/app/report', this.refNo]);
					}, error: (error) => {
						this.showLoader = false;
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}, error: (error) => {
				this.showLoader = false;
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	accordionToggled(j: number, isExpanded: any) {
		let len1 = this.apptListFiltered.length;
		for (let i = 0; i < len1; i++) {
			this.apptListFiltered[i].categoryWiseQues[j].isExpanded = isExpanded;
		}
	}

	getBgClass(index: number) {
		let cls = "bg-";
		cls = cls + ((index) % 4);
		return cls;
	}

	formatDate(dateStr: string) {
		try {
			if (dateStr) {
				return moment(dateStr, "YYYY-MM-DD").format("DD-MM-YYYY");
			} else {
				return dateStr;
			}
		} catch (error) {
			return dateStr;
		}
	}
}
